const CONSTANT = {
    AGORA: {
        APP_ID: "5bdad3a8e45b4c32a5f25f63957a6316",
        APP_CERT: "afc7de35b63b46baa22f99e238e7b8af",
    }
}

export default CONSTANT;